module.exports = __webpack_public_path__ + "img/success.5aeb1925.png";